import { render, staticRenderFns } from "./studentCard.vue?vue&type=template&id=205461ab&scoped=true"
import script from "./studentCard.vue?vue&type=script&lang=js"
export * from "./studentCard.vue?vue&type=script&lang=js"
import style0 from "./studentCard.vue?vue&type=style&index=0&id=205461ab&prod&lang=scss"
import style1 from "./studentCard.vue?vue&type=style&index=1&id=205461ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205461ab",
  null
  
)

export default component.exports